export const resetStore = () => ({
  type: 'RESET',
});
